module.exports = __webpack_public_path__ + "img/FGr_FK_Fernmeldetrupp.d4c7ecc8.svg";